export default [
  /*
  {
    name: '__sequence',
    title: '#',
    titleClass: 'center aligned',
    dataClass: 'center aligned',
  },
  */
  {
    name: '__checkbox',
    titleClass: 'text-center',
    dataClass: 'text-center',
  },
  {
    name: '__slot:index',
    title: '#',
  },
  {
    name: '__slot:titlelink',
    title: 'Title',
  },
  /*
  {
    name: 'orgName',
    title: 'Organization',
    sortField: 'orgName',
    titleClass: 'center aligned',
    dataClass: 'center aligned',
  },
  {
    name: 'repoName',
    title: 'Repository',
    sortField: 'repoName',
    titleClass: 'center aligned',
    dataClass: 'center aligned',
  },
  */
  {
    name: '__slot:issueNumber',
    title: 'Issue #',
  },
  {
    name: 'createdAt',
    title: 'Created At',
    titleClass: 'center aligned',
    dataClass: 'center aligned',
  },
  /*
  {
    name: 'salary',
    sortField: 'salary',
    titleClass: 'center aligned',
    dataClass: 'right aligned',
    callback: 'handleSalary',
    direction: 'des',
  },
  {
    name: '__component:custom-actions',
    title: 'Actions',
    titleClass: 'center aligned',
    dataClass: 'center aligned',
  },
 */
];



// WEBPACK FOOTER //
// ./src/components/FieldDefs.js